export const convertTextWithSymbols = (text) => {
    if (!text) {
        return;
    }

    return text.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
};
